import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/trade_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  type_eq: {
    column_type: 'type',
    extra: {
      options: ['AllotTrade', 'RedeemTrade', 'AchievementPayTrade', 'CashDividendTrade', 'DividendReinvestmentTrade'],
    },
    model_name: 'Trade',
    column_name: 'type',
  },
  type_not_in: {
    column_type: 'type',
    extra: {
      options: [],
    },
    model_name: 'Trade',
    column_name: 'type',
  },
  account_id_eq: {
    column_type: 'belongs_to',
    column_name: 'account',
    extra: {
      model_name: 'Account',
    },
    model_name: 'Trade',
  },
  account: {
    column_type: 'belongs_to',
    column_name: 'account',
    extra: {
      model_name: 'Account',
    },
    model_name: 'Trade',
  },
  fund_id_eq: {
    column_type: 'belongs_to',
    column_name: 'fund',
    extra: {
      model_name: 'Fund',
    },
    model_name: 'Trade',
  },
  fund: {
    column_type: 'belongs_to',
    column_name: 'fund',
    extra: {
      model_name: 'Fund',
    },
    model_name: 'Trade',
  },
  state_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Trade',
      options: ['pending', 'confirmed'],
    },
    model_name: 'Trade',
    column_name: 'state',
  },
}
export const formColumnsConfig = {
  'self': {
    'type': { required: true, disabledUpdate: false },
    'account_id': { required: true, disabledUpdate: false },
    'fund_id': { required: true, disabledUpdate: false },
    'amount': { required: true, disabledUpdate: false },
    'share': { required: true, disabledUpdate: false },
    'value': { required: true, disabledUpdate: false },
    'confirm_date': { required: true, disabledUpdate: false },
    'confirm_file': { required: true, disabledUpdate: false },
    'parent_id': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Trade', columns), filterColumnsExtend)
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Trade', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
